import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollManager {
  constructor(el) {
    this.dom = {el: el};
    this.dom.header = document.querySelector('[data-js="header"] .st-header__inner');

    this.headerStyle = getComputedStyle(this.dom.header);

    this.getStyle = this.getStyle.bind(this);

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    document.body.dataset.color = 'dark';
    ScrollTrigger.batch(this.dom.el, {
      onEnter: ({progress, direction, isActive}) => {
        document.body.dataset.color = 'default';
      },
      onEnterBack: ({progress, direction, isActive}) => {
        document.body.dataset.color = 'dark';
      },
      start: `bottom 0%+=${this.headerStyle.paddingTop}`,
      end: `bottom .5%+=${this.headerStyle.paddingTop}`,
      markers: false,
    });

    window.addEventListener('resize', this.getStyle);
  }

  getStyle() {
    this.headerStyle = getComputedStyle(this.dom.header);
  }
}

export default ScrollManager